import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowUp } from 'react-icons/fa';
import { CONTACT } from '../data/contact';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link" aria-label="LogitsLab — home">
              <img
                src="/assets/images/brand/logitslab-logo.png"
                alt=""
                className="footer-logo-img"
                width="40"
                height="40"
              />
              <span className="logo-wordmark">
                LogitsLab<span className="logo-dot">.</span>
              </span>
            </Link>
            <p className="footer-tagline">
              Production AI for vision, language, and multimodal systems.
              Official partner of Byondbites. Makers of{' '}
              <a
                href="https://mind.logitslab.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MindKshetra
              </a>
              .
            </p>
          </div>

          <div>
            <p className="footer-col-title">Company</p>
            <ul className="footer-links">
              <li>
                <Link to="/partners" className="footer-link">
                  Partners
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="footer-link">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="footer-link">
                  Notes
                </Link>
              </li>
              <li>
                <Link to="/connect" className="footer-link">
                  Connect
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="footer-col-title">Contact</p>
            <div className="footer-meta">
              <a href={CONTACT.emailHref}>{CONTACT.email}</a>
              <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
              <span>{CONTACT.office.label}</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} {CONTACT.siteName}. All rights reserved.
          </p>
          <button
            type="button"
            className="scroll-to-top"
            onClick={scrollToTop}
            aria-label="Scroll to top"
          >
            <FaArrowUp size={12} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
